<template>
  <div>
    <div
      v-for="game in yeekeeGames"
      :key="`yeekee-${game.id}`"
      class="mt-1 main-game-result"
    >
      <div class="game-type">
        <span class="py-1 px-2 mx-3 white--text ">{{ game.name }}</span>
      </div>

      <YeekeeColumn
        :game-rounds="lastGameResult(game)"
        disabled
      ></YeekeeColumn>
    </div>
  </div>
</template>
<script>
import YeekeeColumn from '@/views-v2/Prize/childs/YeekeeColumn'
import { anonymous as apiAnonymous } from '@/apis'

export default {
  components:{ YeekeeColumn },
  data: () => ({
    games: [],
  }), 
  computed: {
    yeekeeGames () {
      return this.games.filter(item => item.id === 1);
    }
  },
  async created () {
    await this.load()
  },
  methods : {
    lastGameResult (game) {
      return game.game_rounds.filter(x => x.round_status.id == 106).slice(-3).reverse();
    },
    async load () {
      let params = {}

      const [err,data] = await apiAnonymous.getLastWin(params)

      if(err) {
        return
      }

      this.games = data
    },
  } 
}
</script>
<style scoped>

.game-type {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  background-color: #606060;
  border-radius: 8px;
  font-size: 18px;
  background-color: var(--bg-secondary-color-v2);
}

.main-game-result {
  background-color: white;
  border-radius: 8px;
  padding: 0 4px;
  padding-top: 4px;
}
</style>